const conversationMessageTypes = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND'
};

export default conversationMessageTypes;